<template>
  <div>
    <div class="cominfo-header">企业中心
      <span>/</span><span>学员中心</span><span>/</span><span>
        <router-link to="/Company/UserList">学员列表</router-link>
      </span><span>/</span>
      <span>{{ruleForm.id?'编辑':'新建'}}学员</span>
    </div>
    <div class="comUserInfo">
      <div class="comUserInfo-header">
        <el-button type="primary" @click="onSave" style="margin: 0 20px;">保存</el-button>
        <el-button type="default" @click="goBack">返回</el-button>
      </div>
      <div class="comUserInfo-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
          style="width: 500px;margin: 20px 0px 20px 100px;text-align: left;padding-bottom: 50px;">
          <el-form-item label="学员ID：" prop="stuid">
            <el-input v-model="ruleForm.stuid" placeholder="请输入学员ID编号"></el-input>
          </el-form-item>
          <el-form-item label="学员姓名：" prop="realName">
            <el-input v-model="ruleForm.realName" placeholder="请输入学员真实姓名"></el-input>
          </el-form-item>
          <el-form-item label="所属组织：" prop="orgId">
            <el-cascader ref="orgCascader" @change="showText=false" :props="props" :visible-change="orgVisible"
              :show-all-levels="false" v-model="orgId" :placeholder="showText?ruleForm.orgName:'选择所属组织'"
              style="width: 100%;">
            </el-cascader>
          </el-form-item>
          <el-form-item label="岗位：" prop="gwId">
            <el-select v-model="gwId" multiple placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in optionGw" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号：" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入学员手机号"></el-input>
          </el-form-item>
          <el-form-item label="">
            该手机号作为登录账号
          </el-form-item>
          <el-form-item label="登录密码：" prop="password">
            <el-input v-model="ruleForm.password" show-password placeholder="请输入登录密码"></el-input>
          </el-form-item>
          <el-form-item label="密码确认：" prop="password">
            <el-input v-model="ruleForm.password1" show-password placeholder="请再次输入密码"></el-input>
          </el-form-item>
          <!-- 密码、组织树、岗位、角色 -->
          <el-form-item label="证件头像：" prop="avatarurl">
            <el-upload action="/safety/file/attachment/upload_new.htm" list-type="picture-card" :show-file-list="false"
              :multiple="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
              :on-remove="delFile">
              <img v-if="ruleForm.avatarurl" :src="wjSrc+ruleForm.avatarurl">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="">
            请上传1寸照片 295px×413px ，大小不可以超过100KB
          </el-form-item>
          <el-form-item label="身份证号：" prop="card">
            <el-input v-model="ruleForm.card" placeholder="请输入学员身份证号"></el-input>
          </el-form-item>
          <el-form-item label="性别：" prop="sex">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      var $this = this;
      return {
        rules: {
          realName: [{
            required: true,
            message: '学员姓名不能为空',
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          }, {
            validator: validatePhone,
            trigger: 'blur'
          }],
          orgId: [{
            required: true,
            message: '所属组织不能为空',
            trigger: 'blur'
          }],
          gwId: [{
            required: true,
            message: '岗位不能为空',
            trigger: 'blur'
          }],
          password: [{
            required: $this.$route.query.id ? false : true,
            message: '密码不能为空',
            trigger: 'blur'
          }],
          password1: [{
            required: $this.$route.query.id ? false : true,
            message: '密码确认不能为空',
            trigger: 'blur'
          }]
        },
        orgVisible: false,
        ruleForm: {
          realName: '',
          stuid: '',
          avatarurl: '',
          card: '',
          sex: '',
          password: '',
          roleCode: 'COM_USER_AQKT',
          orgId: '',
          state: '1',
          orgName: '',
          phone: '',
          id: ''
        },
        orgId: [],
        gwId: [],
        circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        props: {
          lazy: true,
          checkStrictly: true,
          lazyLoad(node, resolve) {
            const {
              level,
              value,
              children
            } = node;
            var loadUrl = '/system/organization/myTree.htm?type=SYS_ORGTYPE_02'
            if (value && children.length == 0) {
              loadUrl += '&id=' + value;
            }
            if (children && children.length > 0) {
              resolve(children);
            } else {
              $this.$axios.get(loadUrl).then(res => {
                var data = res.data;
                if (data.length > 0) {
                  resolve($this.getNodes(data));
                } else {
                  resolve([]);
                }
              })
            };
          },
        },
        optionGw: [],
        showText: false
      }
    },
    methods: {
      handleAvatarSuccess(res, file) {
        if (this.ruleForm.avatarurl) {
          this.delFile(this.ruleForm.avatarurl);
        }
        this.$set(this.ruleForm, 'avatarurl', res.data.filePath);
      },
      beforeAvatarUpload(file) {
        const isSize = new Promise(function(resolve, reject) {
          let width = 295;
          let height = 413;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
            let valid = img.width <= width && img.height <= height;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          return file;
        }, () => {
          this.$message.error('上传的图片必须是等于或小于 295*413 !');
          return Promise.reject();
        });
        const isLt2M = file.size / 1024 < 100;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 100 KB!');
        }
        return isLt2M && isSize;
      },
      getNodes: function(arr) {
        const nodes = arr.map(item => ({
          value: item.id,
          label: item.text,
          leaf: !item.isParent,
          children: item.children.length > 0 ? this.getNodes(item.children) : []
        }));
        return nodes;
      },
      onSave: function() {
        var $this = this;
        var nodes = this.$refs.orgCascader.getCheckedNodes(1)[0]; //所属部门
        if (nodes) {
          this.$set(this.ruleForm, 'orgId', this.orgId[this.orgId.length - 1]);
        };
        this.$set(this.ruleForm, 'gwId', this.gwId.join(','));
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if (this.ruleForm.password1 != this.ruleForm.password) {
              this.$message.error("两次密码输入不一致，请重新输入");
              return;
            }
            if (nodes) {
              this.$set(this.ruleForm, 'orgName', nodes.label);
            };
            if (!this.ruleForm.id) {
              // 新增   账号等于手机号
              this.$set(this.ruleForm, 'loginName', this.ruleForm.phone);
            }
            // 岗位
            this.$set(this.ruleForm, 'gwName', this.getGwname(this.ruleForm.gwId));

            // 修改  账号不变

            delete this.ruleForm.password1;
            this.$axios.post('/system/user_role/COM_USER_AQKT/save.htm', this.$qs.stringify(this.ruleForm))
              .then(res => {
                var data = res.data;
                if (data.stat == '1') {
                  this.$message({
                    message: '学员信息保存成功！',
                    type: 'success',
                    duration: 1000,
                    onClose: function() {
                      $this.$router.go(-1);
                    }
                  });
                } else {
                  if (data.message.indexOf('帐号已存在') >= 0) {
                    this.$message.error('手机号已存在，请使用其他账号');
                  } else {
                    this.$message.error(data.message);
                  }
                }
              })
          } else {
            return false;
          }
        });
      },
      goBack: function() {
        this.$router.go(-1);
      },
      getData: function(id) {
        this.$axios.get('/system/user_role/COM_USER_AQKT/load.htm?id=' + id).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.ruleForm = {
              realName: data.data.realName,
              loginName: data.data.loginName,
              stuid: data.data.stuid,
              avatarurl: data.data.avatarurl,
              card: data.data.card,
              sex: data.data.sex,
              roleCode: 'COM_USER_AQKT',
              orgId: data.data.orgId,
              state: '1',
              orgName: data.data.orgName,
              phone: data.data.phone,
              id: data.data.id,
              gwId: data.data.gwId,
              gwName: data.data.gwName
            };
            this.gwId = data.data.gwId.split(',');
            this.orgId = [data.data.orgId]
            this.showText = true;

          } else {
            this.$message.error(data.message);
          }
        })
      },
      delFile: function(filePath) {
        if (filePath) {
          return;
        }
        var arr = filePath.split('/');
        var arr0 = arr[arr.length - 1].split('.');
        var fileId = arr0[0]
        this.$axios.post('/file/attachment/del.htm', this.$qs.stringify({
          id: fileId
        })).then(
          res => {
            var data = res.data;
            if (data.stat == '1') {

            } else {
              // this.$message.error(data.message);
            }
          })
      },
      // 获取岗位列表
      getGwlist: function() {
        // optionGw
        this.$axios.get('/system/gangwei/list.htm?page=1&rows=100').then(
          res => {
            var data = res.data;
            this.optionGw = data.rows;
          })
      },
      getGwname: function(ids) {
        var names = [];
        this.optionGw.map((item) => {
          var index = ids.indexOf(item.id)
          if (index >= 0) {
            names[index] = item.name;
          }
        })
        return names.join(',');
      }
    },
    created: function() {
      // 人员详情
      this.getGwlist();
      if (this.$route.query.id) {
        this.getData(this.$route.query.id)
      }
    }
  }
</script>
<style>
  .comUserInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .comUserInfo-header {
    height: 70px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    text-align: right;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  }

  .avatar {
    width: 29.5px;
    height: 41.3px;
  }

  .orgNameSpan {
    position: absolute;
    top: 0px;
    left: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/UserInfo.vue